export { PoolTabGroupe } from "./pool-tab-groupe";
